import { ApiContext } from '../../types'
import getCurrentBearerToken from '../authentication/getCurrentBearerToken'

export default async function updatePaymentState(
  { client, config }: ApiContext,
  payment_id,
  state,
): Promise<any> {
  try {
    const token = await getCurrentBearerToken({
      client,
      config,
    })

    // if (params.filter) {
    //   params.filter.number_cont = params.filter.number
    //   params.filter.state_cont = params.filter.state
    // }
    const response = await client.payment.updatePaymentState(
      { bearerToken: token },
      payment_id,
      { payment: { state: state } },
    )
    if (response.isSuccess()) {
      // const payload = response.success()
      // console.log(payload)
      // const data = payload.data.map((order) =>
      //   deserializePayout(order, payload.included, config),
      // )
      // return { ...payload, data }
      return true
    } else {
      throw response.fail()
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
